class EventEmitter {
  constructor() {
    this.listeners = {};
    this.EVENT_TYPES = {
      WS_CONNECTED: "wsCon",
      WS_DISCONNECTED: "wsDis",
      SUBSCRIBE_TO_VEHICLES: "subVeh",
      ON_VEHICLE_DATA: "onVeh",
      ON_LAST_SEEN: "getLastSeen",
      UNSUBSCRIBE_TO_VEHICLES: "unsubVeh",
      LEASED_VEHICLES_FETCHED: "leasedVehFetched",
      RELAY_STATE: "relayFromSeller",
      ORDER_STATUS_UPDATED: "orderStatusUpdated",
      SUBSCRIBE_FOR_WIRELESS_TESTING: "subscribeWirelessTesting",
      WIRELESS_TESTING_SUCCESSFULL: "wirelessTestingSuccessfull",
      UNSUBSCRIBE_FROM_WIRELESS_TESTING: "unsubscribeWirelessTesting",
      LITE_CMD_RESP: "getLiteCmdResp",
      ON_BIKES: "bikes",
      TIMELINE_START_SHARING: "tlStartSharing",
      TIMELINE_STOP_SHARING: "tlStopSharing",
      RELAY: "relay",
      VEHICLE_INFO_SHOWN: "vehicleInfoBoxShown",
      SET_CURRENT_RLS: "setCurrentRls",
      GET_TL_EVENTS: "getTimelineEvents",
      GET_LOC_EVENTS: "getLocEvents",
      SUB_VEH: "subVeh",
      LOCATION_EVENTS: "loc_event",
      RT_LOC_EVT: "real_time_loc",
      LOC_EVT: "loc_evt",
      RELAY_DONE: "relay_done",
      RELAY_ERR: "relay_err",
    };
  }

  addEventListener(eventName, func) {
    if (!eventName) {
      console.error("Trying to listen on undefined event in addEventListener", func);
    }

    if (!func) {
      console.error("Received undefined function in addEventListener ", eventName);
    }

    if (typeof func != "function") return;

    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    } else if (this.listeners[eventName].indexOf(func) >= 0) return;

    this.listeners[eventName].push(func);
  }

  removeEventListener(eventName, func) {
    if (typeof func != "function") return;

    if (func && this.listeners[eventName]) {
      var index = this.listeners[eventName].indexOf(func);
      if (index >= 0) this.listeners[eventName].splice(index, 1);
    }
  }

  removeAllListeners(eventName) {
    delete this.listeners[eventName];
  }

  emitEvent(eventName, ...args) {
    if (!eventName) {
      console.error("Trying to emit undefined event", eventName);
    }

    if (this.listeners[eventName]) {
      this.listeners[eventName].forEach((el) => {
        el(...args);
      });
    }
  }

  emitEventWithCallback(eventName, callback, ...args) {
    if (!eventName) {
      console.error("Tring to emit undefined event", eventName);
    }

    if (this.listeners[eventName]) {
      this.listeners[eventName].forEach((el) => {
        return callback(el(...args));
      });
    }
  }
}

export default EventEmitter;
